import { Component, effect, input, model, output } from '@angular/core';
import {
  SectionNotApplicableChange,
  SectionState,
} from '../../state/installation-reporting-mdu-section-state.types';
import { SectionNotApplicableCardComponent } from '../section-not-applicable-card/section-not-applicable-card.component';
import { SectionNotApplicableFormComponent } from '../section-not-applicable-form/section-not-applicable-form.component';

@Component({
  selector: 'app-section-not-applicable',
  imports: [
    SectionNotApplicableCardComponent,
    SectionNotApplicableFormComponent,
  ],
  templateUrl: './section-not-applicable.component.html',
  styleUrl: './section-not-applicable.component.scss',
})
export class SectionNotApplicableComponent {
  state = input.required<SectionState>();
  isSaving = input(false);
  isEnteringReason = model(false);

  changed = output<SectionNotApplicableChange>();

  constructor() {
    effect(() => {
      this.resetReasonWhenNotApplicable();
    });
  }

  onConfirm(comment: string): void {
    this.changed.emit({ notApplicable: true, comment });
  }

  onCancel(): void {
    this.isEnteringReason.set(false);
  }

  onReactivate(): void {
    this.changed.emit({ notApplicable: false, comment: null });
  }

  private resetReasonWhenNotApplicable(): void {
    if (this.state().notApplicable) {
      this.isEnteringReason.set(false);
    }
  }
}
